import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FormContainer = styled.div`
  max-width: 300px;
  margin: 0 auto;
  padding: 3rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Button = styled.button`
  background-color: #007bff;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const ContentContainer = styled.div`
  flex: 1;
  padding: 20px;
  text-align: center;
`;

const ContentContainer2 = styled.div`
  min-width: 300px;
  flex: 1;
  padding: 20px;
  text-align: center;
  margin-top: 7rem;
  padding-top: 2rem;
  border: 2px solid #007bff;
  border-radius: 1rem;
`;

const Title = styled.h1`
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #666;
  padding-top: 8px;
`;

const SignupForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignUp = (e) => {
    e.preventDefault();
  };

  return (
    <FormContainer>
      <ContentContainer2>
        <ContentContainer>
          <Title>SignUp</Title>
        </ContentContainer>
        <Form onSubmit={handleSignUp}>
          <Input
            type="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit">Sign Up</Button>
        </Form>
        <Description>
          Already have account?
          <Link to="/signin">
            {" "}
            <span className="underline">SignIn</span>
          </Link>
        </Description>
      </ContentContainer2>
    </FormContainer>
  );
};

export default SignupForm;
